var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQobuz(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 400,
    height: 400,
    className: "platformIcon",
    viewBox: "-1 -1 26 26",
    style: {
      fill: "currentcolor",
      opacity: 1
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.543 18.566A9.961 9.961 0 0 0 22 12c0-5.523-4.477-10-10-10S2 6.477 2 12s4.477 10 10 10a9.953 9.953 0 0 0 5.6-1.714l-1.394-1.372a8.092 8.092 0 1 1 1.98-1.697l-2.064-2.049c-.848-.34-1.44.546-1.107 1.298l5.618 5.527 1.176-1.176-2.266-2.251z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 15.13a3.13 3.13 0 1 0 0-6.26 3.13 3.13 0 0 0 0 6.26zm0-2.443a.687.687 0 1 0 0-1.374.687.687 0 0 0 0 1.374z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQobuz);
export default __webpack_public_path__ + "static/media/qobuz.cfaede762f64041808b4737a9c3aaefa.svg";
export { ForwardRef as ReactComponent };